import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    Output,
} from '@angular/core';

import { DashboardPageItem } from '../../../pages/dashboard/interfaces/dashboard-page-item.interface';
import { inputSubtext } from '../chat-container/constants';

@Component({
    selector: 'mapp-landing-modal',
    templateUrl: './landing-modal.component.html',
    styleUrls: ['./landing-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class LandingModalComponent {
    readonly DEFAULT_LEGAL_DISCLAIMER = inputSubtext;

    @Input() modalInfo: DashboardPageItem;

    @Input() showLaunch = true;

    @Output() navigate = new EventEmitter<string>();

    @Output() whenClose = new EventEmitter<void>();

    isVisible = false;

    /**
     *
     * @param cdr
     */
    constructor(private cdr: ChangeDetectorRef) {}

    /**
     *
     */
    openModal(): void {
        this.isVisible = true;
        this.cdr.detectChanges();
    }

    /**
     *
     */
    closeModal(): void {
        this.isVisible = false;
        this.cdr.detectChanges();

        this.whenClose.emit();
    }
}
